/**
 * @fileoverview AppConfig
 *
 */
'use strict';
// Util Import
import * as ConstUtil from './util/ConstUtil';

/**
 * 設定<br>
 *
 * <ul>
 * <li>ログ 表示設定
 * <li>ログ 保存設定
 * <li>接続先
 * </ul>
 * @name AppConfig
 */
const AppConfig = {
  // ログ
  log: {
    // コンソール表示設定
    console: {
      enable: true,
      level: ConstUtil.Common.LOG_LEVEL.debug
    },
    // ログ保存設定
    record: {
      enable: true,
      level: ConstUtil.Common.LOG_LEVEL.debug
    }
  },
  // デバッグ
  isDebug: false,
  // 接続先
  // accessPoint: 'http://172.26.9.180',
  accessPoint: 'http://localhost',
  // APIポート番号
  // apiPortNumber: ':8104',
  apiPortNumber: ':53439',
  // APPポート番号
  appPortNumber: ':8006',
  // ポータルドメイン
  portalDomain: 'localhost',
  // // ポータルAPIポート番号
  // poratlApiPort: ':8701',
  poratlApiPort: ':53437',
  // バージョン情報
  versionInformation: {
    // api: '/api/2.0',
    api: '',
    version: 'localDebug',
    revision: ''
  },
  // HTTPスキーマ
  httpScheme: 'http://',
  // キー情報名
  keyName: ConstUtil.Message.COMMON.ID522,
  // GoogleMap
  googleMap: {
    apiKey: 'AIzaSyDXH9GJED5SrniPg6geRCnd3jBv290nwxk',
    zoom: 12
  }
};

export default AppConfig;



// WEBPACK FOOTER //
// ./src/js/AppConfig.jsx